import { GREEN_COLOUR, RED_COLOUR, YELLOW_COLOUR } from '@/constants/colours'

const RED_YELLOW_COLOUR = '#F4B05A'
const YELLOW_GREEN_COLOUR = '#A9F06E'

export default {
	props: {
		reverseColor: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getValueColor (value) {
			if (value < 4) {
        return this.minColor
      } else if (value < 8) {
        return YELLOW_COLOUR
      } else {
        return this.maxColor
      }
		}
	},
	computed: {
		maxColor () {
			return this.reverseColor ? RED_COLOUR : GREEN_COLOUR
		},
		minColor () {
			return this.reverseColor ? GREEN_COLOUR : RED_COLOUR
		},
		mediumColor () {
			// Darken the color a bit
			return '#cdd62d'
		},
		firstQuartileColor () {
			return this.reverseColor ? YELLOW_GREEN_COLOUR : RED_YELLOW_COLOUR
		},
		thirdQuartileColor () {
			return this.reverseColor ? RED_YELLOW_COLOUR : YELLOW_GREEN_COLOUR
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixins/clinicHistoryVariableColors.mixin.js